import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {SupplierDeliveryItem} from '../core/SupplierDeliveryRecordModel'

type Props = {
  item: SupplierDeliveryItem
  onImageClick: (imageUrl: string) => void // Add the handler prop type
}

const SupplierDeliveryRecordRow: FC<Props> = ({item, onImageClick}) => {
  const {formatMessage} = useIntl()

  // Placeholder image if item.image is missing
  const placeholderImage = '/media/stock/ecommerce/1.gif' // Adjust path if needed

  return (
    <tr>
      <td>
        <div className='symbol symbol-75px'> {/* Increased size from 50px to 75px */}
          <img
            src={item.image || placeholderImage} // Thumbnail uses 'image'
            alt={item.product_name}
            onClick={() => onImageClick(item.big_image || item.image || placeholderImage)} // Pass big_image or fallback
            style={{cursor: 'pointer', width: '75px', height: '75px', objectFit: 'contain'}} // Add pointer cursor and explicit size
          />
        </div>
      </td>
      <td>{item.barcode}</td> {/* Was itemCode */}
      <td>{item.model}</td> {/* Added Model data cell */}
      <td>{item.product_name}</td> {/* Was itemName */}
      <td>{item.date_event_occurred}</td> {/* Was deliveryDate */}
      <td>{parseInt(item.quantity, 10)}</td> {/* Was quantityDelivered, parse string to number, ensure text-end for consistency */}
      <td>{item.offer_warehouse_quantity ?? 0}</td> {/* Multi-supplier: current offer FC stock */}
    </tr>
  )
}

export {SupplierDeliveryRecordRow}
